import { WithTranslation } from 'react-i18next';
import { BrowserInterface } from '@api/store';
import { RouteComponentProps } from 'react-router-dom';

import { StatisticsChannelsState } from '@api/store/channels/types';
import { ExportChannelsParams } from '@api/services/ElasticApi';
import { AccountState } from '@api/store/account/types';

type MatchParams = {
    search?: string;
    channelName?: string;
};

export default interface ChannelsProps extends WithTranslation, RouteComponentProps<MatchParams> {
    classes: any;
    browser: BrowserInterface;
    channels?: StatisticsChannelsState;
    account?: AccountState;
}

export interface ChannelsState {
    unreadyToRender: boolean;
    channelStatisticsValues: string;
    tabValue: number;
    selectedChannels: string[];
    selectedAllCheckboxes: boolean;
    exportOptions: ExportChannelsParams;
}

export enum ChannelsToggleBtnValues {
    Number = 'number',
    Percent = 'percent',
}
export interface ChannelsToggleBtnOptInterface {
    label: string;
    value: ChannelsToggleBtnValues;
}
